import React, { FC, useState } from "react";
import { Table, TablePaginationConfig } from "antd";
import { Link } from "react-router-dom";
import getColumnSearchProps from "../Layout/Common/Adapters/TableFilter";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { PrivateUIRoutes } from "../../router";
import { IEmailTemplate } from "../../models/email-template.model";
import { IResultResponse } from "../../models/response/result.model";

const List: FC = () => {
  const [filter, setFilter] = useState({
    sortPropertyName: null,
    sortAscending: false,
  });

  const { fetchedData, loading } = useHttpGet<
    IResultResponse<IEmailTemplate[]>
  >(`${APIRoutes.EMAIL_TEMPLATES}`, {
    dependencies: [filter],
    query: {
      ...filter,
    },
    defaultValue: {} as IResultResponse<IEmailTemplate[]>,
    reject: CommonService.showAllErrors,
  });

  const handleTableChange = (
    newPagination: TablePaginationConfig,
    filters: any,
    sorter: any
  ) => {
    const newFilter: any = { ...filter };

    newFilter.subject =
      filters?.subject?.length > 0 ? filters?.subject[0] : null;

    if (!!sorter) {
      newFilter.sortPropertyName = sorter.field;
      newFilter.sortAscending = sorter?.order === "ascend";
    }

    setFilter(newFilter);
  };

  const columns = [
    {
      title: "Subject",
      dataIndex: "subject",
      sorter: true,
      ...getColumnSearchProps("subject"),
    },
    {
      title: "",
      dataIndex: "id",
      render: (text: any, record: IEmailTemplate) => {
        return (
          <Link
            className="c-blue"
            to={`/${PrivateUIRoutes.CONTROL_PANEL}/${PrivateUIRoutes.VIEW_EMAIL_TEMPLATES_BASE}/${record?.id}`}
          >
            Edit
          </Link>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={fetchedData.result || []}
      onChange={handleTableChange}
      pagination={false}
      rowKey="id"
      loading={loading}
      size="small"
    />
  );
};

export default List;
